import Taboo from "./Taboo";

const tabooGame = {
  slug: "taboo",
  name: "Taboo",
  landing: {
    accentColor: "#d65a50",
    penguinPose: "penguin-right",
  },
  component: Taboo,
};

export default tabooGame;
